import { HostBinding, Component, ElementRef, Renderer2 } from '@angular/core';

@Component({
  selector: 'bp-button-toolbar, bp-btn-toolbar',
  exportAs: 'bpButtonToolbar',
  template: `<ng-content></ng-content>`
})
export class BpButtonToolbarComponent {
  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.renderer.addClass(this.el.nativeElement, 'btn-toolbar');
    this.renderer.setAttribute(this.el.nativeElement, 'role', 'toolbar');
  }
}
